import React from 'react';
import { connect } from 'react-redux';
import { Form, Header } from 'semantic-ui-react';
import { Form as FinalForm, Field } from 'react-final-form';
import { Link } from 'react-router-dom';

// Actions
// @ts-ignore
import { login } from 'services/auth/actions';

// Global Components
import ErrorAlert from 'components/ErrorAlert';
// @ts-ignore
import LoadingButton from 'components/LoadingButton';

// Form
// @ts-ignore
import { validators, RenderField } from 'forms';

// Validators
const { composeValidators, isRequired, isEmail } = validators;

// Constants
const NAMESPACE = 'LOGIN_LOAD';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

interface Props {
    error?: string;
    login: Function;
}

class LoginForm extends React.PureComponent<Props> {
    handleSubmit = (values: Record<string, any>): void => {
        const { login: requestLogin } = this.props;

        requestLogin(values.username, values.password);
    };

    render(): React.ReactElement {
        return (
            <FinalForm
                onSubmit={this.handleSubmit}
                render={({ handleSubmit, values }): React.ReactElement => (
                    <Form autoComplete="off" onSubmit={handleSubmit}>
                        <Header as="h3">
                            {`Login to your ${REACT_APP_PROJECT_NAME} account`}
                        </Header>
                        <Field
                            name="username"
                            component={RenderField as any}
                            label="Email"
                            type="email"
                            validate={composeValidators(isRequired, isEmail)}
                        />
                        <Field
                            name="password"
                            component={RenderField as any}
                            label="Password"
                            type="password"
                            validate={isRequired}
                        />
                        <ErrorAlert namespace={NAMESPACE} />
                        <LoadingButton namespace={NAMESPACE} primary fluid>
                            Login
                        </LoadingButton>
                        <p>
                            {"Don't have an account? "}
                            <a href="https://www.orchardhand.com/signup/">
                                Sign up
                            </a>
                        </p>
                        <p>
                            {'Forgot your password? '}
                            <Link
                                to={{
                                    pathname: '/reset-password',
                                    state: { username: values.username }
                                }}
                            >
                                Reset password
                            </Link>
                        </p>
                    </Form>
                )}
            />
        );
    }
}

export default connect(
    null,
    { login }
)(LoginForm);
